import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {CompanyModel, CompanyModelForList, NewCompanyModel} from "../models/company";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse, AxiosPromise} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";

export class CompanyService {
    private static basicUrl = apiUrls.dictionaries.companies;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams, name?: string, taxNo?: string): Promise<AxiosResponse<PageableModel<CompanyModelForList>>> {
        if (sortingAndFilteringParams) {
            const nameFilter = name && `name~:${name}`;
            const taxNoFilter = taxNo && `taxNo~:${taxNo}`;
            sortingAndFilteringParams.filterCondition = `${nameFilter}${name && taxNo && ","}${taxNoFilter}`;
        }

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get(url);
    }

    public static async getCompany(id: string): Promise<AxiosResponse<CompanyModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async removeCompany(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addCompany(data: NewCompanyModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async modifyCompany(data: NewCompanyModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }
}
